export default {
  "volcanic_region": "Nossa Região Vulcânica",
  "volcanic_region_description": "Descubra o que torna nossos cafés tão especiais e como a região vulcânica contribui para o desenvolvimento de sabores únicos e complexos.",
  "specialty_coffees": "Cafés Especiais",
  "specialty_coffees_description": "Nossos cafés são cultivados em solos vulcânicos ricos em minerais, proporcionando sabores únicos e complexos.",
  "sustainability": "Sustentabilidade",
  "sustainability_description": "Práticas agrícolas sustentáveis que preservam o ecossistema e garantem a qualidade do produto.",
  "volcanic_terroir": "Terroir Vulcânico",
  "volcanic_terroir_description": "A geografia única da região vulcânica confere características distintas aos nossos cafés.",
  "awarded": "Premiados",
  "awarded_description": "Nossos produtores recebem reconhecimento internacional pela qualidade excepcional.",
  "community": "Comunidade",
  "community_description": "Apoiamos as comunidades locais e promovemos práticas de comércio justo.",
  "global_presence": "Presença Global",
  "global_presence_description": "Exportamos para mais de 30 países, levando o sabor único dos cafés vulcânicos ao mundo.",
  "learn_more": "Conheça Mais Sobre Nossa Região"
}
